<template>
  <input-select
    single
    v-model="cedente"
    :search="pesquisaCedente"
    :options="cedentes"
    placeholder="Selecione"
    :disabled="disabled"
    :required="required"
    @input="emiteInput"
  />
</template>

<script>
export default {
  data () {
    return {
      cedente: null,
      cedenteAnterior: null,
      cedentes: []
    }
  },
  props: {
    banco: { default: '' },
    agencia: { default: '' },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    mostrarInativo: { type: Boolean, default: true }
  },
  methods: {
    emiteInput (val) {
      if (val && this.cedenteAnterior != val) {
        this.$emit('input', val)
      }
      this.cedenteAnterior = val
    },
    carregaCedentes (cedente) {
      if (cedente === '') return
      if ((this.banco && this.agencia) || !this.mostrarInativo) {
        let th = this
        this.$api.Cedentes.ComboPorBancoAgencia(
          this.banco,
          this.agencia,
          cedente,
          this.mostrarInativo
        ).then(function (data) {
          if (Array.isArray(data)) {
            let arrayCedentes = []
            data.forEach(item => {
              arrayCedentes.push({
                value: item.guid,
                text: item.string
              })
            })
            th.cedentes = arrayCedentes
          }
        })
      }
    }
  },
  created () {
    this.pesquisaCedente = _.debounce(this.carregaCedentes, 300)
  }
}
</script>